import './style.scss';

import React from 'react';
import Card from '../ui/card';
import AccountDetails from './accountDetails';
import Payment from './payment';
import Promos from './promos';

function AccountPage() {
  return (
    <div className="account-page banner-padding">
      <div className="account-page__container">
        <section className="account-page__section">
          <h2 className="account-page__heading">Account Details</h2>
          <Card block>
            <AccountDetails />
          </Card>
        </section>
        <section className="account-page__section">
          <h2 className="account-page__heading">Payment Methods</h2>
          <Card block>
            <Payment />
          </Card>
        </section>
        <section className="account-page__section">
          <h2 className="account-page__heading">Promos & Gift Cards</h2>
          <Card block>
            <Promos />
          </Card>
        </section>
      </div>
    </div>
  );
}

export default AccountPage;



// WEBPACK FOOTER //
// ./shared/components/account/index.js